<template>
  <div>
    <app-spinner v-if="!is_loaded"/>
    <div v-else class="driver">
      <app-cells position="between">
        <app-cells :indent="false">
          <h1 class="title">
            {{ driver.first_name }} {{ driver.last_name }}
          </h1>
          <span class="title__update">Last Update: {{ dateTimeFormat(driver.updated_at) }}</span>
        </app-cells>
        <app-button v-if="!driver.block" size="small" theme="error" @click.native="$modal.show('block-modal')">
          Block driver
        </app-button>
      </app-cells>
      <div v-if="driver.block" class="attention-info">
        <img alt="" src="@/assets/img/warning-icon.svg">
        <p>{{ driver.block_reason }}</p>
      </div>
      <app-cells>
        <app-textarea v-model="driver.notes" placeholder="Write a notes" rows="5" />
      </app-cells>
      <div class="driver__wrapper">
        <div class="driver__part">
          <div class="driver__name">
            <img alt="personal" src="@/assets/img/personal-details.svg">
            <span>Personal & Contact details</span>
          </div>
          <div class="driver__row">
            <app-form-group label="First name" label-for="first_name" required>
              <app-input
                id="first_name"
                v-model="driver.first_name"
                :error="$v.driver.first_name.$error"
                name="first_name"
                placeholder="First name"
              />
              <template #error>
                <div v-if="$v.driver.first_name.$dirty && !$v.driver.first_name.required">
                  Required field
                </div>
              </template>
            </app-form-group>
            <app-form-group label="Last name" label-for="last_name" required>
              <app-input
                id="last_name"
                v-model="driver.last_name"
                :error="$v.driver.last_name.$error"
                name="last_name"
                placeholder="Last name"
              />
              <template #error>
                <div v-if="$v.driver.last_name.$dirty && !$v.driver.last_name.required">
                  Required field
                </div>
              </template>
            </app-form-group>
            <app-form-group label="Company">
              <app-select
                v-model="driver.rental_company"
                :options="safari_rental_company_options"
                :reduce="item => item.id"
                placeholder="Company"
              />
            </app-form-group>
            <app-form-group class="form-group--switcher" label="Operations manual signed">
              <app-switcher v-model="driver.op_manual_signed"/>
            </app-form-group>
          </div>
          <div class="driver__row">
            <app-form-group label="Main phone">
              <app-phone v-model="driver.phone" placeholder="+7 499 113 28 00"/>
            </app-form-group>
            <app-form-group class="form-group--center" label="Other communications">
              <app-cells :indent="false">
                <app-checkbox v-model="driver.phone_telegram" :readonly="!driver.phone" label="Telegram"/>
                <app-checkbox v-model="driver.phone_whatsapp" :readonly="!driver.phone" label="Whatsapp"/>
              </app-cells>
            </app-form-group>
            <app-form-group label="Additional phone">
              <app-phone v-model="driver.additional_phone" placeholder="+7 499 113 28 00"/>
            </app-form-group>
            <app-form-group class="form-group--center" label="Other communications">
              <app-cells :indent="false">
                <app-checkbox
                  v-model="driver.additional_phone_telegram"
                  :readonly="!driver.additional_phone"
                  label="Telegram"
                />
                <app-checkbox
                  v-model="driver.additional_phone_whatsapp"
                  :readonly="!driver.additional_phone"
                  label="Whatsapp"
                />
              </app-cells>
            </app-form-group>
          </div>
          <div class="driver__row">
            <app-form-group label="Driver licence" label-for="driver_licence">
              <app-input
                id="driver_licence"
                v-model="driver.driver_licence"
                name="driver_licence"
                placeholder="National ID"
              />
            </app-form-group>
            <app-form-group label="Driver licence (Expire)">
              <app-date-picker v-model="driver.driver_licence_expire" placeholder="Specify a date" />
            </app-form-group>
            <app-form-group label="Driver licence (Scan copy)">
              <app-uploader
                v-model="driver.driver_licence_scancopy"
                :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                class="custom-uploader--flex"
                formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
              />
            </app-form-group>
          </div>
          <div class="driver__row">
            <app-form-group label="Safari Guiding license" label-for="safari_guiding_license">
              <app-input
                id="safari_guiding_license"
                v-model="driver.safari_guiding_license"
                name="safari_guiding_license"
                placeholder="Safari Guiding license"
              />
            </app-form-group>
            <app-form-group label="Safari Guiding license code" class="form-group--no-indent">
              <app-input
                id="safari_guiding_license"
                v-model="driver.safari_guiding_license_code"
                name="safari_guiding_license"
                placeholder="Safari Guiding license"
              />
            </app-form-group>
            <app-form-group label="Safari guiding license (Expire)">
              <app-date-picker v-model="driver.safari_guiding_license_expire" placeholder="Specify a date" />
            </app-form-group>
            <app-form-group label="Safari guiding license (Scan copy)">
              <app-uploader
                v-model="driver.safari_guiding_license_scancopy"
                :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                class="custom-uploader--flex"
                formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
              />
            </app-form-group>
          </div>
        </div>
        <app-cells :indent="false" position="end">
          <app-button ref="save_driver" @click.native="onUpdateDriverData">
            Save
          </app-button>
        </app-cells>
      </div>
    </div>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      class="modal-not-overflow"
      draggable=".popup__title"
      name="block-modal"
    >
      <div class="popup">
        <button class="popup__close" type="button" @click="$modal.hide('block-modal')"></button>
        <div class="popup__title">Block driver</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckBlockForm">
            <app-form-group label="Reason" label-for="block_reason" required>
              <app-textarea
                id="block_reason"
                v-model="block.reason"
                :error="$v.block.reason.$error"
                placeholder="Write a reason"
                rows="5"
              />
              <template #error>
                <div v-if="$v.block.reason.$dirty && !$v.block.reason.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells :indent="false" position="center">
              <app-button ref="submit_block" :disabled="$v.block.$error" type="submit">Block</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getSafariDriver, getSafariRentalCompany, patchSafariDriver } from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'SafariDriversDetail',
  data() {
    return {
      is_loaded: false,
      driver: null,
      safari_rental_company_options: [],
      current_modal_state: 'create',
      vaccines_options: [],
      block: {}
    }
  },
  validations: {
    driver: {
      first_name: { required },
      last_name: { required }
    },
    block: {
      reason: { required }
    }
  },
  created() {
    getSafariDriver(this.$route.params.id)
      .then(res => {
        this.driver = res.data
        this.is_loaded = true
      })
    getSafariRentalCompany().then(res => {
      this.safari_rental_company_options = res.data
    })
  },
  methods: {
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    onUpdateDriverData(data) {
      this.$v.driver.$touch()
      if (this.$v.driver.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly'
        })
      } else {
        this.sendDriverData()
      }
    },
    sendDriverData() {
      this.$refs.save_driver.preload = true
      patchSafariDriver(this.$route.params.id, this.normalizeDriverForm())
        .finally(() => {
          this.$refs.save_driver.preload = false
        })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved successfully'
          })
        })
    },
    normalizeDriverForm() {
      const normalized = { ...this.driver }

      if (normalized.rental_company && typeof normalized.rental_company !== 'number') {
        normalized.rental_company = normalized.rental_company.id
      }
      if (normalized.driver_licence_scancopy && normalized.driver_licence_scancopy.id) {
        normalized.driver_licence_scancopy = normalized.driver_licence_scancopy.id
      } else normalized.driver_licence_scancopy = null
      if (normalized.safari_guiding_license_scancopy && normalized.safari_guiding_license_scancopy.id) {
        normalized.safari_guiding_license_scancopy = normalized.safari_guiding_license_scancopy.id
      } else normalized.safari_guiding_license_scancopy = null

      return normalized
    },
    onCheckBlockForm() {
      this.$v.block.$touch()
      if (this.$v.block.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly'
        })
      } else {
        this.sendModalBlockForm()
      }
    },
    sendModalBlockForm() {
      this.$refs.submit_block.preload = true
      patchSafariDriver(this.$route.params.id, { block: true, block_reason: this.block.reason })
        .finally(() => {
          this.$refs.submit_block.preload = false
        })
        .then(() => {
          getSafariDriver(this.$route.params.id).then(res => {
            this.driver = res.data
          })
          this.$modal.hide('block-modal')
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.driver__wrapper
  max-width: 1080px

  +max-w($laptop_md)
    max-width: 100%

.driver__name
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 25px
  color: #181818
  font-weight: 500

.driver__name--no-indent
  margin-bottom: 0

.driver__part
  margin-bottom: 20px

.driver__part--more-indent
  margin-bottom: 40px

.driver__row
  display: grid
  gap: 10px 20px
  grid-template-columns: repeat(4, 1fr)
  margin-bottom: 20px

  +max-w($laptop_md)
    grid-template-columns: repeat(2, 1fr)

.driver__row--double
  grid-template-columns: 420px

</style>
